module.exports = __webpack_public_path__ + "img/marcapais-gov.96a6a615.svg";